import React from 'react';
import { CgArrowLongRight } from 'react-icons/cg';
import { Link } from 'react-router-dom';
import { TUTORCARD } from '../../assets/images';

export default function FindTutor() {
  return (
    <div className="flex flex-col container py-10 m-auto">
      {/*find perfect tutor div */}
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="w-full md:w-3/5 flex md:items-start items-center flex-col gap-10">
          <div className="basis-1/4">
            <span className="text-base md:text-lg font-medium text-neutralBlue2">FOR PARENT / STUDENT</span>
          </div>
          <div className="flex flex-col md:items-start items-center gap-8">
            <div>
              <h1 className="text-2xl md:text-4xl font-extrabold text-white">Find The Perfect Tutor</h1>
            </div>
            <div>
              <p className="text-base md:text-lg font-normal text-white w-full md:w-10/12 leading-relaxed text-center md:text-start">
                Looking for a great way to improve your Skills? WorlOTutor provides you with qualified teachers. Hire an
                online tutor to help you improve your skills.
              </p>
            </div>
          </div>
        </div>
        <div className="flex md:p-10 my-5">
          <img src={TUTORCARD} alt="Find a tutor" />
        </div>
      </div>
      <div className="grid md:grid-cols-3 md:grid-rows-1 grid-rows-3 grid-cols-1 py-5 gap-8">
        <Link to="/explore/subject" className="bg-secondary flex flex-col justify-between py-2 px-4">
          <span className="text-xl font-medium text-white">Browse by Subject</span>
          <span className="flex justify-end">
            <CgArrowLongRight color="white" size={40} />
          </span>
        </Link>
        <Link to="/find-tutor" className="bg-secondary flex flex-col justify-between py-2 px-4 cursor-pointer">
          <span className="text-xl font-medium text-white">Browse by Tutor</span>
          <span className="flex justify-end">
            <CgArrowLongRight color="white" size={40} />
          </span>
        </Link>
        <Link to="/post-requirement" className="bg-secondary flex flex-col justify-between py-2 px-4 cursor-pointer">
          <span className="text-xl font-medium text-white w-3/4">Let Us Help You Find The Right Tutor</span>
          <span className="flex justify-end">
            <CgArrowLongRight color="white" size={40} />
          </span>
        </Link>
      </div>
    </div>
  );
}
